/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React, { Fragment, useState } from 'react'

import usePermissions from '@modules/permissions-lib/hooks'
import TagsPanel from '@modules/resources-shared-components/Tags/TagsPanel'
import { useGetDeploymentQuery } from '@modules/cloud-lib/deployments/hooks'

import { getDeploymentTags } from '@/lib/stackDeployments/selectors/metadata'

import DeploymentTagsFlyout from './DeploymentTagsFlyout'

const DeploymentTagsPanel = ({ deploymentId }: { deploymentId: string }) => {
  const { data: deployment } = useGetDeploymentQuery(deploymentId)

  const tags = deployment ? getDeploymentTags({ deployment }) : []

  const { hasPermissions: hasUpdatePermission } = usePermissions([
    { type: 'deployment', action: 'update', id: deploymentId },
  ])

  const [isFlyoutOpen, setIsFlyoutOpen] = useState(false)

  return (
    <Fragment>
      <TagsPanel
        tags={tags}
        onAddTagsClick={() => setIsFlyoutOpen(true)}
        hasPermissionsToAddTags={hasUpdatePermission}
      />
      {isFlyoutOpen && (
        <DeploymentTagsFlyout
          deploymentId={deploymentId}
          tags={tags}
          onClose={() => setIsFlyoutOpen(false)}
        />
      )}
    </Fragment>
  )
}

export default DeploymentTagsPanel
